// fiuhb_frontend/src/services/finance_services/proformaService.js
import { API_BASE_URL } from '../../constants/appConstants';
import { authenticatedRequest } from '../authService';

const Finance_Base_Url = `${API_BASE_URL}/finances`;

// Proforma Services
export const getProformas = async (page = 1, pageSize = 10, filters = {}, invitationId = null) => {
  const params = new URLSearchParams({
    page: page.toString(),
    page_size: pageSize.toString()
  });
  
  // Add optional filter parameters
  if (filters.search) {
    params.append('search', filters.search);
  }
  if (filters.status) {
    params.append('status', filters.status);
  }
  if (filters.client) {
    params.append('client', filters.client);
  }
  if (filters.date_range) {
    params.append('date_range', filters.date_range);
  }
  if (filters.start_date) {
    params.append('start_date', filters.start_date);
  }
  if (filters.end_date) {
    params.append('end_date', filters.end_date);
  }
  if (filters.expiry_date_range) {
    params.append('expiry_date_range', filters.expiry_date_range);
  }
  if (filters.expiry_start_date) {
    params.append('expiry_start_date', filters.expiry_start_date);
  }
  if (filters.expiry_end_date) {
    params.append('expiry_end_date', filters.expiry_end_date);
  }
  
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Finance_Base_Url}/proformas/?${params.toString()}`;
  try {
    const response = await authenticatedRequest(url, {
      method: 'GET',
    });
    return response;
  } catch (error) {
    console.error('Error fetching proformas:', error);
    throw error;
  }
};

export const createProforma = async (proformaData, invitationId = null) => {
  const params = new URLSearchParams();
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Finance_Base_Url}/proformas/create/?${params.toString()}`;
  console.log('Creating proforma with data:', proformaData);
  
  try {
    const response = await authenticatedRequest(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(proformaData),
    });
    console.log('Create proforma response:', response);
    return response;
  } catch (error) {
    console.error('Error creating proforma:', error);
    throw error;
  }
};

export const getProforma = async (proformaId, invitationId = null) => {
  const params = new URLSearchParams();
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Finance_Base_Url}/proformas/${proformaId}/?${params.toString()}`;
  try {
    const response = await authenticatedRequest(url, {
      method: 'GET',
    });
    return response;
  } catch (error) {
    console.error('Error fetching proforma:', error);
    throw error;
  }
};

export const updateProforma = async (proformaId, proformaData, invitationId = null) => {
  const params = new URLSearchParams();
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Finance_Base_Url}/proformas/${proformaId}/update/?${params.toString()}`;
  try {
    const response = await authenticatedRequest(url, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(proformaData),
    });
    return response;
  } catch (error) {
    console.error('Error updating proforma:', error);
    throw error;
  }
};

export const deleteProforma = async (proformaId, invitationId = null) => {
  const params = new URLSearchParams();
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Finance_Base_Url}/proformas/${proformaId}/delete/?${params.toString()}`;
  try {
    const response = await authenticatedRequest(url, {
      method: 'DELETE',
    });
    return response;
  } catch (error) {
    console.error('Error deleting proforma:', error);
    throw error;
  }
};

